export const toggleClass = (element, clss) => {
  element.classList.contains(clss)
    ? element.classList.remove(clss)
    : element.classList.add(clss);
};
